<template lang="pug">
  .positionSelector.container
    p.positionSelector__title.col-md-4.offset-md-2.col-md-offset-1 職位(權限)*
    select.positionSelector__select.col-md-6(
      :value="selectedPositionId"
      :disabled="disabled"
      :class="{'positionSelector__select--disabled': disabled }"
      @change="handlePositionChanged($event)")
      option.positionSelector__option(
        v-for="position in positionIdAndNameList"
        :value="position.id"
      ) {{ position.name }}
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  computed: {
    ...mapGetters({
      selectedPositionId: 'positionStore/getSelectedPositionId',
      positionIdAndNameList: 'positionStore/getPositionIdAndNameList',
    }),
  },
  methods: {
    handlePositionChanged(event) {
      const { value } = event.target
      this.$emit('change', parseInt(value, 10))
    },
  },
}
</script>
<style lang="scss" scoped>
.positionSelector {
  &__title {
    text-align: center;
    font-size: 16px;
    margin-bottom: 0;
    line-height: 36px;
  }

  &__select {
    position: relative;
    padding: 6px 12px;
    font-size: 16px;
    color: #555;
    border: 1px solid #ccc;
    border-radius: 4px;
    background: #fff;
    height: 36px;

    &--disabled {
      background: #d8d8d8;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/manager/PositionSelector.vue